"use client";

export function BackgroundEffects() {
  return (
    <>
      {/* Background gradients */}
      <div className="bg-container fixed inset-0 pointer-events-none overflow-hidden z-0">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_0%,rgba(139,92,246,0.15)_0%,transparent_50%),radial-gradient(ellipse_60%_40%_at_20%_80%,rgba(34,197,94,0.1)_0%,transparent_40%),radial-gradient(ellipse_60%_40%_at_80%_60%,rgba(59,130,246,0.1)_0%,transparent_40%)]" />
      </div>

      {/* Stars */}
      <div
        className="stars fixed inset-0 pointer-events-none bg-[radial-gradient(2px_2px_at_20px_30px,rgba(255,255,255,0.4),transparent),radial-gradient(2px_2px_at_40px_70px,rgba(255,255,255,0.3),transparent),radial-gradient(1px_1px_at_90px_40px,rgba(255,255,255,0.5),transparent)] bg-repeat animate-[twinkle_8s_ease-in-out_infinite]"
        style={{ backgroundSize: "200px 150px" }}
      />
    </>
  );
}
